import { render, staticRenderFns } from "./UploadsWidget.vue?vue&type=template&id=d621a2bc&"
import script from "./UploadsWidget.vue?vue&type=script&lang=js&"
export * from "./UploadsWidget.vue?vue&type=script&lang=js&"
import style0 from "./UploadsWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports